module.exports = __webpack_public_path__ + "static/media/heebo.478a2e1d.ttf";